import React from "react";
import "./PlantATree.scss";

export function PlantATree() {
  return (
    <div className="plant-a-tree-success-badge">
      <div className="plant-a-tree-success-badge__tree-emoji">🌳</div>
      <p>
        As a thank you for booking your event with VenueScanner we'll plant a
        tree on your behalf.
      </p>
    </div>
  );
}
